import {history} from "./history";


const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

export const getLocation = canUseDOM ? location : history.location;